import { Checkbox, cn } from "@nexus/ui";
import { useTranslation } from "react-i18next";

/** 44×44 touch target; shrink on fine-pointer desktops so dense tables stay compact. */
const HIT_TARGET_CLASS =
  "inline-flex min-h-11 min-w-11 items-center justify-center [@media(hover:hover)_and_(pointer:fine)]:min-h-0 [@media(hover:hover)_and_(pointer:fine)]:min-w-0";

export interface PersonaOpportunitySelectCheckboxProps {
  /** `"indeterminate"` marks a header checkbox whose group is partly selected. */
  checked: boolean | "indeterminate";
  disabled?: boolean;
  onToggle: () => void;
  className?: string;
  /** Overrides the default “Select opportunity” label. */
  label?: string;
}

/**
 * Shared row/card selection control — design-system Checkbox inside a
 * coarse-pointer 44px hit area with focus-visible from `@nexus/ui`.
 */
export function PersonaOpportunitySelectCheckbox({
  checked,
  disabled = false,
  onToggle,
  className,
  label,
}: PersonaOpportunitySelectCheckboxProps) {
  const { t } = useTranslation();

  return (
    <span
      className={cn(HIT_TARGET_CLASS, className)}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <Checkbox
        checked={checked}
        disabled={disabled}
        onCheckedChange={() => {
          if (disabled) return;
          onToggle();
        }}
        onClick={(event) => event.stopPropagation()}
        aria-label={
          label ?? t("personaOpportunities.active.selectRow", "Select opportunity")
        }
        className="size-4 data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground"
      />
    </span>
  );
}
